import { useState } from 'react'
import PropTypes from 'prop-types'
import { useStyletron } from 'baseui'
import { useTranslation } from 'react-i18next'
import copyToClipboard from '@/shared/tools/copyToClipboard'
import useClientTabRedesign from './useClientTabRedesign'

// Same clipboard / check icons as the fields' CopyEndEnhancer.
const ClipboardIcon = () => (
  <svg viewBox='0 0 24 24' width={16} height={16} fill='currentColor' aria-hidden='true'>
    <path d='M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z' />
  </svg>
)

const CheckIcon = () => (
  <svg viewBox='0 0 32 32' width={16} height={16} fill='currentColor' aria-hidden='true'>
    <polygon points='14 21.414 9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414' />
  </svg>
)

const keepEventInButton = e => e.stopPropagation()

// Copy icon meant to live inside a tab title. Unlike the shared CopyEndEnhancer it:
// - copies on the first click (onMouseDown stops the tab from stealing focus first),
// - uses a lightweight native title tooltip instead of a large overlay.
const CopyContractLink = ({ value }) => {
  const [, theme] = useStyletron()
  const { t } = useTranslation()
  const [copied, setCopied] = useState(false)
  const isPulse = useClientTabRedesign()
  const idleColor = isPulse ? 'currentColor' : theme.colors.primaryA

  const handleCopy = async e => {
    e.preventDefault()
    e.stopPropagation()
    if (!value) return
    if (!(await copyToClipboard(value))) return
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  return (
    <button
      type='button'
      title={copied ? t('common:copied') : t('common:copy')}
      onMouseDown={keepEventInButton}
      onKeyDown={keepEventInButton}
      onClick={handleCopy}
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: copied ? 'green' : idleColor,
      }}
    >
      {copied ? <CheckIcon /> : <ClipboardIcon />}
    </button>
  )
}

CopyContractLink.propTypes = {
  value: PropTypes.string,
}

export default CopyContractLink
